import omit from 'lodash/omit';
import keys from 'lodash/keys';
import {connect} from "~/redux/connect";
import {push} from "redux-little-router";
import PropTypes from 'prop-types';
import React, {Component, forwardRef} from "react";
import getConfig from "~/config";
import { Link } from '~/native-ui';
import { mergeRefs } from 'native-base/src/utils/mergeRefs';

const pushLinkPropTypes = {
    push: PropTypes.func.isRequired,
    href: PropTypes.string.isRequired,
    delay: PropTypes.bool,
    isHovering: PropTypes.bool,
    trans: PropTypes.func,
    language: PropTypes.string,
    fallbackLanguage: PropTypes.string,
    children: PropTypes.node,
    enableLinks: PropTypes.bool,
    forwardedRef: PropTypes.any,
};

const neededPushLinkProps = keys(pushLinkPropTypes);

class _PushLink extends Component {
    static propTypes = pushLinkPropTypes;

    static defaultProps = {
        enableLinks: getConfig().admin_enable_links !== 0
    }

    clickPush = (e) => {
        let { push, href } = this.props;

        e.stopPropagation();
        e.preventDefault();

        // window.location = `${href}`;

        push(href, { forceChangeRootModel: true });

        return false;
    };

    clickDefault = (e) => {
        e.stopPropagation()
    };

    clickNothing = (e) => {
        e.stopPropagation();
        e.preventDefault();
        return false;
    };

    delayProps = (addDelay = false) => {
        let { isHovering, href } = this.props;
        if (addDelay && this.props.delay) return {}

        if(href && href.match(/^(mailto:)|(http)|(https)|(tel:)/)) {
            if(!addDelay || isHovering || !this.props.delay) {
                return { onClick: this.clickDefault, href }
            } else {
                return { onClick: this.clickNothing }
            }
        }

        if(!addDelay || !this.props.delay) {
            return {
                onClick: this.clickPush
            };
        }

        return {
            onClick: isHovering ? this.clickPush : null,
        }
    };

    ref = React.createRef(null);
    setRef = (node) => {
        this.ref = node;
        if (this.props.target && node) {
            node.setAttribute("target", this.props.target);
        }
    }


    render() {
        const { children = null, forwardedRef, href } = this.props;
        if (!this.props.enableLinks) {
            return <React.Fragment>{children}</React.Fragment>;
        }

        let other = omit(this.props, neededPushLinkProps);

        return <Link ref={mergeRefs([forwardedRef, this.setRef])} { ...other} { ...this.delayProps() } href={href}>{children}</Link>;
    }
}

const _PushLinkWrapper = forwardRef(({delay, ...props}, ref) => {
    return <_PushLink {...props} forwardedRef={ref} />
});

export const PushLink = connect(null, (dispatch) => {
    return {
        push: (...args) => dispatch(push(...args)),
    }
}, null, { forwardRef: true })(_PushLinkWrapper);

export const DelayLink = (props) => {
    return <PushLink delay {...props} />
};